import { render, staticRenderFns } from "./form-log-active.vue?vue&type=template&id=6f9005f1&"
import script from "./form-log-active.vue?vue&type=script&lang=js&"
export * from "./form-log-active.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports